module.exports = __webpack_public_path__ + "img/banner4.6e0b43b2.png";